import { Component } from '@angular/core';

@Component({
    selector: 'footer',
    template: require('./footer.component.html')
})
export class FooterComponent { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/footer/footer.component.ts